import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Container, Form, Input, Menu, Message } from 'semantic-ui-react';
import { setLogin } from '../../Api/api';
import { isPhoneNumberOk } from '../../helpers';
import styles from './LoginPage.module.css';

enum Step {
    Phone,
    PhoneWithCode,
}

interface LoginPageProps {
    onLoggedIn: () => void;
}

function LoginPage(props: LoginPageProps) {
    const { onLoggedIn } = props;

    const [phone, setPhone] = useState('');
    const [code, setCode] = useState('');
    const [step, setStep] = useState(Step.Phone);
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (step === Step.PhoneWithCode) {
            inputRef.current.focus();
        }
    }, [step]);

    const request = function () {
        if (!isPhoneNumberOk(phone, false, false)) {
            toast.error('Некорректный номер телефона');
            return;
        }

        setLoading(true);

        setLogin(phone, step === Step.PhoneWithCode ? code : null)
            .then(() => {
                if (step === Step.Phone) {
                    setStep(Step.PhoneWithCode);
                    toast.success('Сообщение с кодом отправлено.');
                } else if (step === Step.PhoneWithCode) {
                    onLoggedIn();
                    navigate("/");
                }
            })
            .catch((error) => {
                setStep(Step.Phone);
                setCode('');
                console.log('error', error)
                toast.error(error.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    const loginWithExistingCode = function () {
        if (!isPhoneNumberOk(phone, false, false)) {
            toast.error('Некорректный номер телефона');
            return;
        }
        setStep(Step.PhoneWithCode);
    }

    return (
        <>
            <Menu borderless>
                <Menu.Item
                    header
                    className={styles['menu-item']}
                    name='Личный кабинет'
                />
            </Menu>

            <Container className={styles['login-container']}>
                <Message
                    attached
                    header='Добро пожаловать!'
                    content='Для входа в учетную запись необходимо подтвердить номер телефона.'
                />

                <Form className={clsx('attached fluid segment', loading ? 'loading' : '')} onSubmit={request}>
                    <Form.Field required>
                        <label>Номер телефона</label>
                        <Input className={step === Step.PhoneWithCode && 'disabled'}
                            type='tel' value={phone} onChange={e => setPhone(e.target.value)}
                        />
                    </Form.Field>

                    {step === Step.PhoneWithCode && <Form.Field required>
                        <label>Код подтверждения</label>
                        <Input ref={inputRef} type='text' value={code} onChange={e => setCode(e.target.value)}
                        />
                    </Form.Field>}

                    <Button.Group fluid widths={2}>
                        <Button color='teal' type="submit" disabled={phone.length < 10}>Продолжить</Button>
                        {step === Step.Phone && <Button type="button" onClick={loginWithExistingCode} disabled={phone.length < 10}>У меня есть код</Button>}
                    </Button.Group>
                </Form>
            </Container>
        </>
    );
}

export default LoginPage;